import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-not-allowed',
    templateUrl: './not-allowed.component.html',
    styleUrl: './not-allowed.component.sass',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotAllowedComponent {}
